import { render } from "./cookies.vue?vue&type=template&id=2ac25958&scoped=true"
import script from "./cookies.vue?vue&type=script&lang=js"
export * from "./cookies.vue?vue&type=script&lang=js"

import "./cookies.vue?vue&type=style&index=0&id=2ac25958&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac25958"]])

export default __exports__